export const PositioningBlockPosition = {
  Sticky: 'sticky',
} as const
export type PositioningBlockPosition =
  (typeof PositioningBlockPosition)[keyof typeof PositioningBlockPosition]
